module.exports = __webpack_public_path__ + "static/media/profile.dea1d9c6.png";